import { useCallback, useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

/**
 * Datos del CRM de administraciones de edificios (colección `administraciones`,
 * sin mapa) + la lista de usuarios comerciales para asignar. Mismo patrón exacto
 * que useDesarrolladorasData: cache a nivel módulo, reload() fuerza refresco,
 * upsertLocal refleja un alta/edición sin releer.
 */
let _cache = null;

async function fetchAll() {
  const [aSnap, comSnap] = await Promise.all([
    getDocs(collection(db, "administraciones")),
    getDocs(query(collection(db, "users"), where("typeuser", "==", 4))),
  ]);
  const administraciones = aSnap.docs.map((d) => ({ id: d.id, ...d.data() }));
  const comerciales = comSnap.docs.map((d) => {
    const x = d.data();
    const name = x.name || `${x.NombreCompleto || ""} ${x.ApellidosCompleto || ""}`.trim();
    return { userid: x.userid, email: String(x.email || "").toLowerCase(), name: name || x.email };
  });
  return { administraciones, comerciales };
}

export function useAdministracionesData() {
  const [state, setState] = useState(() =>
    _cache ? { ..._cache, loading: false, error: null }
           : { administraciones: [], comerciales: [], loading: true, error: null }
  );

  const load = useCallback(async (force = false) => {
    if (_cache && !force) { setState({ ..._cache, loading: false, error: null }); return; }
    setState((s) => ({ ...s, loading: true }));
    try {
      _cache = await fetchAll();
      setState({ ..._cache, loading: false, error: null });
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: e }));
    }
  }, []);

  useEffect(() => { load(false); }, [load]);

  const upsertLocal = useCallback((id, data) => {
    const base = _cache || { administraciones: [], comerciales: [] };
    const list = base.administraciones.slice();
    const idx = list.findIndex((a) => a.id === id);
    if (idx >= 0) list[idx] = { ...list[idx], ...data, id };
    else list.unshift({ id, ...data });
    _cache = { ...base, administraciones: list };
    setState({ ..._cache, loading: false, error: null });
  }, []);

  return { ...state, reload: () => load(true), upsertLocal };
}
